import { render, staticRenderFns } from "./ReportingSettings.vue?vue&type=template&id=4e13e0f7&scoped=true"
import script from "./ReportingSettings.vue?vue&type=script&lang=js"
export * from "./ReportingSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e13e0f7",
  null
  
)

export default component.exports